import { render } from "./AddonMaps.vue?vue&type=template&id=812ce08c&scoped=true"
import script from "./AddonMaps.vue?vue&type=script&lang=js"
export * from "./AddonMaps.vue?vue&type=script&lang=js"

import "./AddonMaps.vue?vue&type=style&index=0&id=812ce08c&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-812ce08c"]])

export default __exports__